// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1op-b","productName":"Table_productName__1VhjN"};